import React, { ReactNode, useEffect } from "react";
import "./FullScreenModal.css";
import { X } from "react-feather";
import { MotionWrapper } from "../MotionWrapper/MotionWrapper";
import HelpIcon from "../HelpIcon/HelpIcon";

interface FullScreenModalProps {
  header: string;
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  helpURL: string;
  dynamicHeight?: boolean; // Optional: allows height to match content instead of fixed 85vh
}

const FullScreenModal: React.FC<FullScreenModalProps> = ({
  header,
  isOpen,
  onClose,
  children,
  helpURL,
  dynamicHeight = false,
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Always render to keep Canvas components mounted
  // Use visibility + pointer-events to hide when closed
  return (
    <MotionWrapper>
      <div
        onClick={handleBackgroundClick}
        className="fullScreenModal"
        style={{
          visibility: isOpen ? "visible" : "hidden",
          pointerEvents: isOpen ? "auto" : "none",
          opacity: isOpen ? 1 : 0,
          transition: "opacity 0.2s ease-in-out",
        }}
      >
        <div
          className={`fullScreenModalContainer ${dynamicHeight ? "dynamicHeight" : ""}`}
        >
          <div className="fullScreenHeader">{header}</div>
          <div
            className={`fullScreenContent ${dynamicHeight ? "dynamicHeight" : ""}`}
          >
            {children}
          </div>
          <div className="fullScreenFooter">
            <X className="closeButton" size={22} onClick={onClose} />
          </div>
        </div>
      </div>
    </MotionWrapper>
  );
};

export default FullScreenModal;
